export const APP_NAME = 'manage-documents';
export const ROUTE_ROOT = '/manage-documents';
export const DIGITAL_DEAL_JACKET_SOURCE = 'Retail360_Managers_View';
export const DIGITAL_DEAL_JACKET_PARTNER_ID = 'MMD';
export const DDJ_SCRIPT_ID = 'ddj-pbc-url';
export const DDJ_PRELOADER_ID = 'ddj-preloader-container';
